import { getRowId } from '../utils/row-id'
import type { DataGrid } from '../types'

export function useCheckbox($grid: DataGrid) {
  const { internalData, reactData } = $grid

  const updateAllCheckboxStatus = () => {
    const rows = reactData.tableData
    const { totalCheckboxMaps } = internalData
    let selected = 0
    rows.forEach((row, index) => {
      if (totalCheckboxMaps[getRowId(row, index)]) selected++
    })
    reactData.isAllSelected = rows.length > 0 && selected === rows.length
    reactData.isIndeterminate = selected > 0 && selected < rows.length
    reactData.checkboxRecordsCount = Object.keys(totalCheckboxMaps).length
  }

  $grid.handleCheckedAllRow = (checked: boolean) => {
    const { totalCheckboxMaps, curCheckboxMaps } = internalData
    reactData.tableData.forEach((row, index) => {
      const rowid = getRowId(row, index)
      if (checked) {
        totalCheckboxMaps[rowid] = row
        curCheckboxMaps[rowid] = row
      } else {
        delete totalCheckboxMaps[rowid]
        delete curCheckboxMaps[rowid]
      }
    })
    reactData.updateCheckboxFlag++
    updateAllCheckboxStatus()
  }

  $grid.handleCheckedRow = (row: Record<string, unknown>, checked: boolean) => {
    const { totalCheckboxMaps, curCheckboxMaps } = internalData
    const rowid = getRowId(row)
    if (checked) {
      totalCheckboxMaps[rowid] = row
      curCheckboxMaps[rowid] = row
    } else {
      delete totalCheckboxMaps[rowid]
      delete curCheckboxMaps[rowid]
    }
    reactData.updateCheckboxFlag++
    updateAllCheckboxStatus()
  }

  $grid.syncCheckboxStatus = () => {
    const { totalCheckboxMaps, curCheckboxMaps } = internalData
    Object.keys(curCheckboxMaps).forEach((key) => delete curCheckboxMaps[key])
    reactData.tableData.forEach((row, index) => {
      const rowid = getRowId(row, index)
      if (totalCheckboxMaps[rowid]) {
        curCheckboxMaps[rowid] = row
      }
    })
    updateAllCheckboxStatus()
  }

  $grid.getAllCheckbox = () => Object.values(internalData.totalCheckboxMaps)

  $grid.isCheckedByCheckboxRow = (row: Record<string, unknown>) => {
    void reactData.updateCheckboxFlag
    return !!internalData.totalCheckboxMaps[getRowId(row)]
  }
}
